import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import addShippingAddressModal from './addShippingAddressModal.vue';
import { loading, userPrefPageSize } from '@/decorators';

var ShippingAddressPage = function (_super) {
  __extends(ShippingAddressPage, _super);

  function ShippingAddressPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.rowSelection = {};
    _this.selectedList = [];
    _this.total = 0;
    _this.loadingStatus = false;
    _this.searchData = _this.initSearchData();
    return _this;
  }

  ShippingAddressPage.prototype.initSearchData = function () {
    return {
      page_index: 1,
      page_size: 10
    };
  };

  ShippingAddressPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('联系人'),
      dataIndex: 'name',
      filterEmpty: true,
      isCopy: true,
      width: 150
    }, {
      title: this.t('联系电话'),
      dataIndex: 'phone',
      filterEmpty: true,
      isCopy: true,
      width: 150
    }, {
      width: 150,
      title: this.t('国家/地区'),
      dataIndex: 'countries_and_regions',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('省州'),
      dataIndex: 'provinces',
      filterEmpty: true,
      isCopy: true,
      width: 150
    }, {
      title: this.t('城市'),
      dataIndex: 'city',
      filterEmpty: true,
      isCopy: true,
      width: 150
    }, {
      title: this.t('详细地址'),
      scopedSlots: {
        customRender: 'detailedaddress'
      }
    }, {
      width: 100,
      title: this.t('操作'),
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      onChange: function onChange(selectedRowKeys) {
        _this.selectedList = selectedRowKeys;
      }
    };
    this.queryShippingAddress();
  };

  ShippingAddressPage.prototype.queryShippingAddress = function () {
    return __awaiter(this, void 0, Promise, function () {
      var resData, _a, _b, list, _c, total;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            return [4, this.$api.warehouse.queryShippingAddress(this.searchData)];

          case 1:
            resData = _d.sent().data;
            _a = resData || {}, _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.total, total = _c === void 0 ? 0 : _c;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ShippingAddressPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryShippingAddress();
  };

  ShippingAddressPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData.ids = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.ids = this.selectedList;
            }

            return [4, this.$api.warehouse.exportShippingAddress(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ShippingAddressPage.prototype.handleDelete = function (id) {
    var _this = this;

    if (!id && !this.selectedList.length) {
      this.$message.warn(this.t('请至少勾选一条记录'));
      return;
    }

    this.$confirm({
      title: this.t('删除提示'),
      content: this.t('确认删除该地址？'),
      onOk: function onOk() {
        _this.deleteAddress(id ? [id] : _this.selectedList);
      }
    });
  };

  ShippingAddressPage.prototype.deleteAddress = function (ids) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, code, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.warehouse.deleteShippingAddress({
              ids: ids
            })];

          case 1:
            _a = _b.sent(), code = _a.code, message = _a.message;

            if (code === 0) {
              this.$message.success(this.t('删除成功'));
              this.queryShippingAddress();
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ShippingAddressPage.prototype.handleAdd = function () {
    var addShippingAddressModal = this.$refs.addShippingAddressModal;
    addShippingAddressModal.modalVisible = true;
  };

  ShippingAddressPage.prototype.handleEdit = function (record) {
    var addShippingAddressModal = this.$refs.addShippingAddressModal;
    addShippingAddressModal.modalVisible = true;
    addShippingAddressModal.addressId = record.id;
    var keys = Object.keys(addShippingAddressModal.addressForm);

    for (var _i = 0, _a = Object.keys(record); _i < _a.length; _i++) {
      var key = _a[_i];

      if (key === 'provinces') {
        addShippingAddressModal.addressForm.province = record[key];
      }

      if (keys.includes(key)) {
        addShippingAddressModal.addressForm[key] = record[key];
      }
    }
  };

  __decorate([userPrefPageSize('shippingAddressBookList')], ShippingAddressPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ShippingAddressPage.prototype, "queryShippingAddress", null);

  ShippingAddressPage = __decorate([Component({
    components: {
      addShippingAddressModal: addShippingAddressModal
    }
  })], ShippingAddressPage);
  return ShippingAddressPage;
}(Vue);

export default ShippingAddressPage;